/**
 * Publications Data
 * Contains academic publications and research papers
 */

import type { Publication } from '@/types';

export const publications: Publication[] = [
  {
    id: 1,
    title: "Image Denoising Using A Combination Of Spatial Domain Filters And Convolutional Neural Networks",
    date: "2019",
    journal: "IJRTE, ISSN: 2277-3878, Volume-7 Issue-6, March 2019",
    details: "We proposes a novel image denoising technique that combines spatial domain filters with a Block Matching Convolutional Neural Network (BMCNN). We evaluated various spatial domain filters (e.g., arithmetic mean, median) and the BMCNN separately, then combine them to tackle different types of image noise (Gaussian, salt and pepper, speckle, Poisson). The BMCNN incorporates hard thresholding, Wiener filtering, and Haar transform with a pre-trained CNN. Performance is measured using Peak Signal-to-Noise Ratio (PSNR). Results show that the combined approach generally outperforms either method used alone, especially for salt and pepper and speckle noise, while remaining computationally efficient. The study highlights the importance of choosing appropriate spatial domain filters to optimize overall denoising performance when combined with BMCNN.",
    link: "https://www.ijrte.org/wp-content/uploads/papers/v7i6/F2810037619.pdf",
    authors: ["Ashraf Ali", "Co-authors"]
  }
];

